"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationEntity = void 0;
var flApi = require("./flApi");
var RootClass = require("./rootClass");
var ApplicationEntity = (function (_super) {
    __extends(ApplicationEntity, _super);
    function ApplicationEntity(jSonDoc) {
        return _super.call(this, "application", jSonDoc, 2) || this;
    }
    ApplicationEntity.load = function (name, bExactMatch) {
        if (bExactMatch === void 0) { bExactMatch = false; }
        return __awaiter(this, void 0, void 0, function () {
            var matchingApps, fl, options, srvApps, i, oneApp, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        matchingApps = [];
                        fl = flApi.Api.getInstance();
                        options = "";
                        if (bExactMatch) {
                            options = "q=c61 = '" + name + "'";
                        }
                        else {
                            options = "q=c61 like '" + name + "%'";
                        }
                        return [4, fl.restApi.getAllDocuments(60, options, 2)];
                    case 1:
                        srvApps = _a.sent();
                        for (i = 0; i < srvApps.length; i++) {
                            oneApp = new ApplicationEntity(srvApps[i]);
                            oneApp.toClass().access.forEach(function (anAcc) {
                                if (anAcc.newUser === undefined) {
                                    anAcc.newUser = false;
                                }
                                if (anAcc.userName === undefined) {
                                    anAcc.userName = "";
                                }
                                if (anAcc.jSon === undefined) {
                                    anAcc.jSon = {};
                                }
                            });
                            matchingApps.push(oneApp);
                        }
                        return [2, matchingApps];
                    case 2:
                        err_1 = _a.sent();
                        console.error(err_1.stack || err_1);
                        err_1 = err_1.stack === undefined ? new Error(err_1) : err_1;
                        throw err_1;
                    case 3: return [2];
                }
            });
        });
    };
    ApplicationEntity.prototype.encode = function (jsonData) {
        return _super.prototype.encode.call(this, jsonData);
    };
    ApplicationEntity.prototype.decode = function () {
        return _super.prototype.decode.call(this);
    };
    ApplicationEntity.prototype.setProp = function (propName, value) {
        return _super.prototype.setProp.call(this, propName, value);
    };
    ApplicationEntity.prototype.save = function () {
        return _super.prototype.save.call(this, 60);
    };
    ApplicationEntity.prototype.postProcess = function () {
        _super.prototype.postProcess.call(this);
    };
    ApplicationEntity.prototype.create = function () {
        return __awaiter(this, void 0, void 0, function () {
            var myApp, srvApp, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        myApp = this;
                        if (myApp.dbServer === null || myApp.dbServer === undefined) {
                            myApp.dbServer = { "host": "default" };
                        }
                        return [4, flApi.Api.getInstance().restApi.insertDocuments(60, myApp.decode(), "", 2)];
                    case 1:
                        srvApp = _a.sent();
                        return [2, this.encode(srvApp[0])];
                    case 2:
                        err_2 = _a.sent();
                        console.error(err_2.stack || err_2);
                        err_2 = err_2.stack === undefined ? new Error(err_2) : err_2;
                        throw err_2;
                    case 3: return [2];
                }
            });
        });
    };
    ApplicationEntity.prototype.delete = function (options) {
        if (options === void 0) { options = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var myApp, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        myApp = this;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, flApi.Api.getInstance().restApi.deleteOneDocument(60, myApp.id, options, 2)];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        err_3 = _a.sent();
                        console.error(err_3);
                        err_3 = err_3.stack === undefined ? new Error(err_3) : err_3;
                        throw err_3;
                    case 4: return [2];
                }
            });
        });
    };
    ApplicationEntity.prototype.grantAccess = function (accessInfo, doNotdisplayError) {
        if (doNotdisplayError === void 0) { doNotdisplayError = false; }
        return __awaiter(this, void 0, void 0, function () {
            var myApp_1, accessInfoArray, newApp, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        myApp_1 = this;
                        accessInfoArray = (accessInfo instanceof Array) ? accessInfo : [accessInfo];
                        accessInfoArray.forEach(function (oneAccessInfo) {
                            var tmpOneAcc = JSON.parse(JSON.stringify(oneAccessInfo));
                            for (var i = myApp_1.access.length; i > 0; i--) {
                                if ((tmpOneAcc.userId !== 0 && myApp_1.access[i - 1].userId === tmpOneAcc.userId) ||
                                    (tmpOneAcc.userId === 0 && myApp_1.access[i - 1].userName === tmpOneAcc.userName)) {
                                    myApp_1.access.splice(i - 1, 1);
                                    i = i - 1;
                                }
                            }
                            if (tmpOneAcc.userId === undefined || tmpOneAcc.userId === null) {
                                throw new Error("invalid parameter, missing userId in access[]");
                            }
                            myApp_1.access.push(tmpOneAcc);
                        });
                        return [4, myApp_1.save()];
                    case 1:
                        newApp = _a.sent();
                        return [2, myApp_1.encode(newApp.decode())];
                    case 2:
                        err_4 = _a.sent();
                        if (!doNotdisplayError) {
                            console.error(err_4.stack || err_4);
                        }
                        err_4 = err_4.stack === undefined ? new Error(err_4) : err_4;
                        throw err_4;
                    case 3: return [2];
                }
            });
        });
    };
    ApplicationEntity.prototype.revokeAccess = function (userId, doNotDisplayError) {
        if (doNotDisplayError === void 0) { doNotDisplayError = false; }
        return __awaiter(this, void 0, void 0, function () {
            var myApp, oldAccessInfo, tmpAccess, i, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        myApp = this;
                        oldAccessInfo = JSON.parse(JSON.stringify(myApp.access));
                        tmpAccess = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        if (userId === myApp.ownerUserId) {
                            throw new Error("Impossible to revoke owner of an application");
                        }
                        for (i = 0; i < myApp.access.length; i++) {
                            if (myApp.access[i].userId !== userId) {
                                tmpAccess.push(myApp.access[i]);
                            }
                        }
                        if (!(myApp.access.length !== tmpAccess.length)) return [3, 3];
                        myApp.access = tmpAccess;
                        return [4, myApp.save()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2, this.toClass()];
                    case 4:
                        err_5 = _a.sent();
                        myApp.access = oldAccessInfo;
                        if (!doNotDisplayError) {
                            console.error(err_5.stack || err_5);
                        }
                        err_5 = err_5.stack === undefined ? new Error(err_5) : err_5;
                        throw err_5;
                    case 5: return [2];
                }
            });
        });
    };
    ApplicationEntity.prototype.toClass = function () {
        return this;
    };
    return ApplicationEntity;
}(RootClass.RootClass));
exports.ApplicationEntity = ApplicationEntity;
